import React from "react";

const HeaderLeft = ({ logo, homeUrl }) => {
    return (
        <div className="header--inside__left">
            <a href={homeUrl} rel="nofollow">
                <img
                    src={logo.url}
                    alt={logo.alt || "Logo"}
                    width={logo.width}
                    height={logo.height}
                    title={logo.title}
                />
            </a>
        </div>
    );
};

export default HeaderLeft;